import React from "react";

interface ShareLinkIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const ShareLinkIcon: React.FC<ShareLinkIconProps> = ({
  size = 18,
  color = 'currentColor',
  className,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M9.79501 8.70508C11.4825 10.3926 11.4825 13.1226 9.79501 14.8026C8.10751 16.4826 5.37751 16.4901 3.69751 14.8026C2.01751 13.1151 2.01001 10.3851 3.69751 8.70508"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.9425 10.5577C6.1875 8.80266 6.1875 5.95266 7.9425 4.19016C9.6975 2.42766 12.5475 2.43516 14.31 4.19016C16.0725 5.94516 16.065 8.79516 14.31 10.5577"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ShareLinkIcon;
